export default function headerSearchReducers (state='', action)	 {
	switch (action.type) {
		case 'Loading':
			return action.payload;
		case 'headerSearch':
			return action.payload;
		case 'Error':
			return action.payload;
		default:
			return state;
	}
}
